import React from 'react';
import { motion } from 'framer-motion';
import { FaDownload, FaEnvelope, FaLinkedin, FaGithub } from 'react-icons/fa';
import styles from './Hero.module.css';

const stats = [
  { value: 'PhD', label: 'Aerospace Engineering' },
  { value: '10+', label: 'Research Projects' },
  { value: '15+', label: 'Publications' },
  { value: '1', label: 'Startup Founded' },
];

const Hero: React.FC = () => {
  const handleContact = () => {
    window.location.href = 'mailto:katambadany@gmail.com';
  };

  return (
    <section id="home" className={styles.hero}>
      <div className={styles.container}>
        <motion.div
          className={styles.layout}
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className={styles.portrait}>
            <img
              src="/photos/profile_dany.jpeg"
              alt="Dr. Dany Katamba"
              className={styles.photo}
            />
          </div>

          <div className={styles.content}>
            <p className={styles.location}>Bari, Italy</p>

            <h1 className={styles.name}>Dr. Dany Katamba</h1>

            <p className={styles.role}>PhD in Aerospace Engineering</p>

            <p className={styles.tagline}>
              R&D specialist in signal processing, structural health monitoring, and AI-driven
              predictive maintenance.
            </p>

            <div className={styles.tags}>
              <span>AI & Data Science</span>
              <span>Condition Monitoring</span>
              <span>Predictive Maintenance</span>
            </div>

            <div className={styles.actions}>
              <a
                href="https://drive.google.com/file/d/1SCXkBJLJlO6pqASYCVGwIhrLO32ElsB8/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.primaryBtn}
              >
                <FaDownload />
                Download CV
              </a>
              <button type="button" className={styles.secondaryBtn} onClick={handleContact}>
                <FaEnvelope />
                Contact
              </button>
              <a
                href="https://www.linkedin.com/in/dany-katamba-mpoyi-555531188/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialBtn}
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </a>
              <a
                href="https://github.com/Katamba94"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialBtn}
                aria-label="GitHub"
              >
                <FaGithub />
              </a>
            </div>
          </div>
        </motion.div>

        <motion.div
          id="about"
          className={styles.stats}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
        >
          {stats.map((stat) => (
            <div key={stat.label} className={styles.statCard}>
              <span className={styles.statValue}>{stat.value}</span>
              <span className={styles.statLabel}>{stat.label}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;